import React from 'react';
import ContentPage from 'components/ContentPage';

export default (contentType, ContentPageComponent) => () => (
  <ContentPage contentType={contentType} ContentPageComponent={ContentPageComponent} />
);
